import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import { Instagram } from 'lucide-react';

const linkSx = {
  color: 'text.secondary',
  textDecoration: 'none',
  fontWeight: 500,
  py: 1,
  '&:hover': { color: 'primary.main' },
};

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        zIndex: 1,
        px: 2,
        pt: 3,
        pb: 'calc(var(--safe-bottom) + 24px)',
        textAlign: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', columnGap: 3, fontSize: 14 }}>
        <Link href="https://www.instagram.com/drinkgroni/" target="_blank" rel="noopener noreferrer" sx={{ ...linkSx, display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
          <Instagram size={16} aria-hidden="true" /> @drinkgroni
        </Link>
        <Link component={RouterLink} to="/privacy" sx={linkSx}>
          Privacy
        </Link>
        <Link component={RouterLink} to="/brand" sx={linkSx}>
          Brand
        </Link>
      </Box>
      <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1 }}>
        © {new Date().getFullYear()} Groni. Please drink responsibly.
      </Typography>
    </Box>
  );
}

export default Footer;
